import React from 'react';
import classnames from 'classnames';
import Card from 'scy/Card';
import { CarouselProductGrid } from 'components/ProductGrid';
import ProductsHeader from 'components/productsHeader';
import CategoryLink from 'components/categoryLink';
import { HoverableImageBackground } from 'scy/Background';
import { H3 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import {
  relative,
  absolute,
  top_0,
  left_0,
  right_0,
  bottom_0
} from 'scy/position.mod.scss';
import { zIndex1 } from 'scy/utils.mod.scss';
import { flex, centerItems, centerContent } from 'scy/flex.mod.scss';
import styles from './curated.mod.scss';

export default function Curated({ curations }) {
  return curations
    .filter(({ products = [] }) => !!products.length)
    .map(({ id, name, products, categories, url_path }) => (
      <Curation
        key={id || name}
        name={name}
        products={products}
        categories={categories}
        url_path={url_path}
      />
    ));
}

function Curation({ name, products = [], categories = [], url_path = null }) {
  return (
    <Card
      className={classnames(
        relative,
        zIndex1,
        margin.bottom_sm,
        padding.left_sm,
        padding.right_sm,
        padding.tablet_right_md,
        padding.tablet_left_md
      )}
    >
      <ProductsHeader url={url_path} title={name} />
      <div className={categories.length ? margin.bottom_md : margin.bottom_sm}>
        <CarouselProductGrid
          products={products}
          trackCategory={`Curation - ${name}`}
        />
      </div>

      {!!categories.length && (
        <div className={styles.categories}>
          {categories.map(({ tag, url, name, image }) => (
            <CategoryLink
              key={url || tag}
              tag={tag}
              url={url}
              className={styles.categoryTile}
            >
              <HoverableImageBackground
                style={{ backgroundImage: `url(${image})` }}
                className={classnames(
                  styles.categoryInnerTile,
                  absolute,
                  top_0,
                  left_0,
                  right_0,
                  bottom_0,
                  flex,
                  centerItems,
                  centerContent
                )}
              >
                <H3>{name}</H3>
              </HoverableImageBackground>
            </CategoryLink>
          ))}
        </div>
      )}
    </Card>
  );
}
